export const pdfLegals = [
    {
        name: 'Beneficios SOAT RIMAC',
        url: 'https://imagescdn.rimac.com/bltc46828409692e1b5/620e8336510c6b1c87b8c0f2/Beneficios_SOAT_Rimac_10.01.22.pptx',
        hideMobile: false,
        hideDesktop: false
    },
    {
        name: 'Calculo Beneficio Repsol',
        url: 'https://imagescdn.rimac.com/blt8fa0d491c93f5faf/620e8a9222fe6d1c86690a81/LEGAL_-_CALCULO_BENEFICIO_REPSOL.pdf',
        hideMobile: false,
        hideDesktop: false
    },
    {
        name: 'Cartilla de siniestros SOAT',
        url: 'https://imagescdn.rimac.com/blt8e3d3bcf7fa59837/61df7f791f6a6a388b94d5d6/5Cartillas-de-siniestros-soat.pdf',
        hideMobile: false,
        hideDesktop: false
    },
    {
        name: 'Descuento Asistencia Vial + Grúa',
        url: 'https://imagescdn.rimac.com/bltc39bf46be6b0dd61/620e8a12fdf6277dc3f32cf8/DESCUENTO_ASIST_VIAL_GRUA_-_SOAT.pdf',
        hideMobile: false,
        hideDesktop: false
    },
    {
        name: 'Descuento baterías ETNA',
        url: 'https://imagescdn.rimac.com/blt4f0bb5d875e1c854/620e8a556d7ac90d6120bdbb/DESCUENTO_BATERIAS_ETNA_-_SOAT_v3.pdf',
        hideMobile: true,
        hideDesktop: false
    },
    {
        name: 'Descuento Gasolina Repsol',
        url: 'https://imagescdn.rimac.com/blt5d606d641f8aa0dd/620e89da081d740d60da1d13/DESCUENTO_GASOLINA_REPSOL_-_SOAT.pdf',
        hideMobile: true,
        hideDesktop: false
    },
    {
        name: 'Descuento Gasolina REPSOL - Estaciones',
        url: 'https://imagescdn.rimac.com/bltda71afdf3781946c/6227a12a3b0a2616b0dfaf4c/LISTA_DE_ESTACIONES_PROMOCARD.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Descuento Revisión técnica CEDITEDV',
        url: 'https://imagescdn.rimac.com/bltb731d4b8c3142558/620e899df2dbfc1b33f7c9cd/DESCUENTO_REVISI%C3%93N_T%C3%89CNICA_CEDITEDV_-_SOAT.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2022',
        url: 'https://imagescdn.rimac.com/blt9ebf22b0e1b6c1fe/63e27e254af54b10f64e8a42/Detalle_de_Siniestros_SOAT_2022.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2022 (Octubre - Noviembre - Diciembre)',
        url: 'https://imagescdn.rimac.com/blt12fed02366f4c708/63e27e1690fb3569e47fbb1e/Detalle_de_Siniestros_SOAT_2022_(Octubre_-_Noviembre_-_Diciembre).pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2021',
        url: 'https://imagescdn.rimac.com/blt46148660df4f3160/63e27e2345febe7be92133f7/Detalle_de_Siniestros_SOAT_2021.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2020',
        url: 'https://imagescdn.rimac.com/blt5b3a76e03eebbf1c/61df7fef67237e39ca823d51/9Detalle-SINIESTROS-SOAT-TRIMESTRE-3-2020.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2019',
        url: 'https://imagescdn.rimac.com/blt14c8bbf38b3618b2/61df80a0e20e6747a087047e/17Detalle_Siniestros_2019.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2018',
        url: 'https://imagescdn.rimac.com/blt261f1a10cfc9789f/61df80c467237e39ca823d59/19Siniestros_SOAT_2018.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2017',
        url: 'https://imagescdn.rimac.com/bltc19688ebe9093d2b/61df80d825d68c388a00ffaa/20Detalle_Siniestros201710.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2016',
        url: 'https://imagescdn.rimac.com/blt6fd8a5456b548437/61df80efae25fe39cb308d6a/21Detalle_de_Siniestros_2016.zip',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2015',
        url: 'https://imagescdn.rimac.com/blt929770dd7d0d9317/61df811836e72847a469ed7b/22Detalle_de_Siniestros2015.zip',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2014',
        url: 'https://imagescdn.rimac.com/blt42c100cf37bf99c0/61df81355ee73041f45e8267/23Detalle_de_Siniestros_2014.zip',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2013',
        url: 'https://imagescdn.rimac.com/blt5661c0fa321c19bd/61df813f5ee73041f45e826b/24Detalle_de_Siniestros_2013.zip',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Detalle de Siniestros SOAT 2023 (Enero - Febrero - Marzo)',
        url: 'https://imagescdn.rimac.com/bltb11a0939486e8153/64489238de40d20defb3cf2d/Detalle_de_Siniestros_SOAT_2023_(Enero_-_Febrero_-_Marzo).pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Fondo de compensación SOAT',
        url: 'https://imagescdn.rimac.com/bltb6da824419e6d329/61df7f6b5ee73041f45e8263/4FONDO_DE_COMPENSACION.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Indemnizaciones por muerte no reclamadas',
        url: 'https://imagescdn.rimac.com/blt85d36965af5315eb/64b598fa3b8ba25b37d1a226/Web_15_Julio_2023.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Nota Técnica SOAT',
        url: 'https://imagescdn.rimac.com/blteeeca902ffd53093/61df7f57b9da3143235e1f9f/3Nota_Tecnica.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2022',
        url: 'https://imagescdn.rimac.com/bltc661ccf4ed8642b2/635c2a85a86a565857b1e823/Primas_SOAT_2022_(2).pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2023',
        url: 'https://imagescdn.rimac.com/blte285a15288591a79/647a389a6dcff2d20896a03c/Primas_Dep_Prov_2023.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Resultado Técnico SOAT 2023',
        url: 'https://imagescdn.rimac.com/blt75002c49e49c7b2c/647a392495957658bd35ea7c/Trimestral_SOAT_-_RT_por_Departamento_y_Provincia_enero-febrero-marzo.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2021',
        url: 'https://imagescdn.rimac.com/bltdce1808205217a19/61f80f3b2f5ed026e153a0bd/Primas-SOAT-2021.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2020',
        url: 'https://imagescdn.rimac.com/blt0406a01620c13111/61df841525d68c388a00ffb6/36Primas-SOAT-2020-actualizado.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2019',
        url: 'https://imagescdn.rimac.com/blt72bf6d8ce9cc2380/61df84340dbc8e41f6a8ba8e/37Primas-SOAT-2019.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2018',
        url: 'https://imagescdn.rimac.com/blt825f656920ffe6fd/61df844336e72847a469ed7f/38Primas_2018.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2023',
        url: 'https://imagescdn.rimac.com/bltf0bbe4e0d6d37be3/647a39986ab748d055f10882/Siniestralidad_Tipo_Vehiculo_2023.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Primas SOAT 2017',
        url: 'https://imagescdn.rimac.com/bltae748d6ec1c9cb26/61df84578eca0643220594ae/39primas_dep_prov_soles.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Resultado Técnico SOAT 2022',
        url: 'https://imagescdn.rimac.com/blt037ca93294f682a9/635c0a12e63a425d5dc5bbfd/Resultado_tecnico_SOAT_2022_(2).pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Resultado Técnico SOAT 2021',
        url: 'https://imagescdn.rimac.com/blt48700883453d46f7/61f80f3be0b919284700b6a3/Resultado-Tecnico-SOAT-2021.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Resultado Técnico SOAT 2020',
        url: 'https://imagescdn.rimac.com/bltd41ad11a29a92e81/61df836967237e39ca823d5d/31Resultado-Tecnico-SOAT-2020-actualizado.pdf',
        hideMobile: true,
        hideDesktop: true
    }
    ,
    {
        name: 'Resultado Técnico SOAT 2019',
        url: 'https://imagescdn.rimac.com/blt76fbe68726621100/61df837f67237e39ca823d61/32Resultado-Tecnico-SOAT-2019.pdf',
        hideMobile: true,
        hideDesktop: true
    }
    ,
    {
        name: 'Resultado Técnico SOAT 2018',
        url: 'https://imagescdn.rimac.com/blt5371d1425f471ed8/61df839867237e39ca823d65/33Resultado_Tecnico_2018.pdf',
        hideMobile: true,
        hideDesktop: true
    }
    ,
    {
        name: 'Resultado Técnico SOAT 2017',
        url: 'https://imagescdn.rimac.com/blt1d576b82c7491de4/61df83ceef369648d52ebb19/34result_tecnico_dep_prov_soles.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2022',
        url: 'https://imagescdn.rimac.com/bltf0b96b8c44597a77/635c0a129a123e5dbdbca287/SINIESTRALIDAD_SOAT_2022.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2021',
        url: 'https://imagescdn.rimac.com/blt0256ff13122a434f/61f80f3c2c429d35c030db24/Siniestralidad-SOAT-2021.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2020',
        url: 'https://imagescdn.rimac.com/blt6c3d3d60e57e5cb8/61df82e05ee73041f45e826f/26Siniestralidad-SOAT-2020-actualizado.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2019',
        url: 'https://imagescdn.rimac.com/blt8ddfac372bc9417a/61df82ee0dbc8e41f6a8ba8a/27Siniestralidad-SOAT-2019.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2018',
        url: 'https://imagescdn.rimac.com/bltf9067cdbff8fea29/61df8308ae25fe39cb308d6e/28Siniestralidad_2018.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Siniestralidad SOAT 2017',
        url: 'https://imagescdn.rimac.com/bltb528b0e6aeb9ce3e/61df833325d68c388a00ffae/29Siniestralidad_Uso_Vehiculo_.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Tarifas Referenciales SOAT - Clínicas Lima',
        url: 'https://imagescdn.rimac.com/blt5971affcd9143f39/61df846ea912ad48dbedf4ac/40SOAT_TarifasReferenciales_ClinicasLima.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Tarifas Referenciales SOAT - Clínicas Provincia',
        url: 'https://imagescdn.rimac.com/bltec7e9f583c9c93b5/61df84ad1f6a6a388b94d5e0/41SOAT_TarifasReferenciales_ClinicasProvincia.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Tarifas Referenciales SOAT - MINSA',
        url: 'https://imagescdn.rimac.com/blt02d711d53adc379c/61df7f3e1f6a6a388b94d5d2/2SOAT_TarifasReferenciales_MINSA.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Términos y Condiciones de SOAT Plus',
        url: 'https://imagescdn.rimac.com/bltfb277a02616439b6/61df84fde20e6747a087048a/45TyC-de-SOAT-PLUS.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Términos y Condiciones de SOAT Taxi Salud',
        url: 'https://imagescdn.rimac.com/blt90eefee99f68025a/61df84dc1f6a6a388b94d5e6/43TyC-de-SOAT-TAXI-SALUD.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Términos y Condiciones de SOAT Vial',
        url: 'https://imagescdn.rimac.com/blt0d7373f83a8cee5a/61df84f21f6a6a388b94d5ea/44TyC-SOAT-VIAL.pdf',
        hideMobile: true,
        hideDesktop: true
    },
    {
        name: 'Términos y Condiciones Revisiones Técnicas',
        url: 'https://imagescdn.rimac.com/blt794af8ab1b15d361/61df84d1e20e6747a0870486/42TyCrevisiones-tecnicas.pdf',
        hideMobile: true,
        hideDesktop: true
    }
];